function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('./../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var LeagueRankings = require('./lib/rankings');
var LeagueLeaderboard = require('./lib/leaderboard');
var LeagueMain = require('./lib/main');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var JoinLeagueOverlay = require('./lib/overlays/join');
var PeerService = require('saito-js/lib/peer_service')["default"];

//Trial -- So that we can display league results in game page
var LeagueOverlay = require('./lib/overlays/league');

//
// League uses 3 URL parameters (which will trigger overlays in Arcade/Redsquare/elsewhere)
// view_game="GameName" (any case) ---> pull up the league_overlay for the default saito leaderboard of said game
// league="id"  --> pull up the league_overlay for the specified league
// league_id="id" --> pull up the join league overlay for the specified league
//
var League = /*#__PURE__*/function (_ModTemplate) {
  function League(app) {
    var _this;
    _classCallCheck(this, League);
    _this = _callSuper(this, League, [app]);
    _this.name = 'League';
    _this.slug = 'league';
    _this.description = 'Leaderboards and leagues for Saito Games';
    _this.categories = 'Arcade Gaming';
    _this.status = 'prod';
    _this["class"] = 'app';
    _this.overlay = null;
    _this.styles = ['/arcade/style.css', '/league/style.css'];
    _this.leagues = [];
    // id
    // game - name of game mod
    // name - name of league
    // admin - publicKey (if exists)
    // status - public or private
    // description
    // ranking_algorithm - e.g. ELO, EXP, HSC
    // default_score: default ranking for newbies

    //
    // UI components
    //
    _this.main = null;
    _this.header = null;

    /* Not fully implemented
      Only keep the last N recent games
      You don't play a game for 30 days, you get dropped from leaderboard
       (should prune data from SQL table or just filter from UI???)
    */
    _this.recent_game_cutoff = 10;
    _this.inactive_player_cutoff = 30 * 24 * 60 * 60 * 1000;
    _this.auto_open_league_overlay_league_id = null;
    _this.icon_fa = 'fas fa-user-friends';
    _this.debug = false;
    _this.last_prune = 0;
    _this.finished_games = [];
    app.connection.on('league-render-into', function (league_id, container) {
      if (!app.BROWSER) {
        return;
      }
      var league = _this.returnLeague(league_id);
      if (!league) {
        return;
      }
      _this.attachStyleSheets();
      var leaderboard = new LeagueLeaderboard(app, _this, container, league);
      leaderboard.render();
    });
    return _this;
  }

  //
  // declare that we support the "league" service, which allows peers to query
  // us for league-related information (leagues, players, leaderboards, etc.)
  //
  _inherits(League, _ModTemplate);
  return _createClass(League, [{
    key: "returnServices",
    value: function returnServices() {
      if (this.app.BROWSER) {
        return [];
      }
      return [new PeerService(null, 'league', null, 'saito')];
    }
  }, {
    key: "respondTo",
    value: function respondTo(type) {
      var _this2 = this;
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type == 'league-membership') {
        var league_self = this;
        return {
          testMembership: function testMembership(league_id) {
            var leag = league_self.returnLeague(league_id);
            if (!leag) {
              return false;
            }
            if (leag.rank < 0) {
              return false;
            }
            if (leag !== null && leag !== void 0 && leag.unverified) {
              return false;
            }
            return true;
          }
        };
      }
      if (type == 'leagues-for-arcade') {
        this.styles = ['/league/style.css'];
        this.attachStyleSheets();
        return {
          returnLeague: function returnLeague(league_id) {
            return _this2.returnLeague(league_id);
          },
          returnLeagues: function returnLeagues() {
            return _this2.leagues;
          }
        };
      }
      return _superPropGet(League, "respondTo", this, 3)([type, obj]);
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this3 = this;
        var game, gm;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(League, "initialize", this, 3)([app]);
            case 1:
              if (!this.app.options.league) {
                this.app.options.league = {};
              }

              // Backward compatibility -> Move the list down a level...
              if (this.app.options.leagues) {
                this.app.options.league.leagues = this.app.options.leagues;
                delete this.app.options.leagues;
              }

              //
              // create initial leagues fresh from the game system
              //
              this.app.modules.getRespondTos('default-league').forEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(modResponse) {
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _context.n = 1;
                        return _this3.addLeague({
                          id: app.crypto.hash(modResponse.modname),
                          // id
                          game: modResponse.game,
                          // game - name of game mod
                          name: modResponse.name,
                          // name - name of league
                          admin: '',
                          // admin - publicKey (if exists)
                          status: 'public',
                          // status - public or private
                          description: modResponse.description,
                          //
                          ranking_algorithm: modResponse.ranking_algorithm,
                          //
                          default_score: modResponse.default_score // default ranking for newbies
                        });
                      case 1:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());

              //
              // Load my local information
              //
              _context2.n = 2;
              return this.loadLeagues();
            case 2:
              if (app.BROWSER) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              //Trial -- So that we can display league results in game page
              this.overlay = new LeagueOverlay(app, this);
              if (!app.browser.returnURLParameter('view_game')) {
                _context2.n = 5;
                break;
              }
              game = app.browser.returnURLParameter('view_game').toLowerCase();
              gm = app.modules.returnModuleBySlug(game);
              if (gm) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2);
            case 4:
              //TODO: Reset the default leagues and make the hashes based on game slugs!!!!
              this.auto_open_league_overlay_league_id = app.crypto.hash(gm.returnName());
              app.connection.emit('league-overlay-render-request', this.auto_open_league_overlay_league_id);
            case 5:
              if (app.browser.returnURLParameter('league')) {
                this.auto_open_league_overlay_league_id = app.browser.returnURLParameter('league');
                app.connection.emit('league-overlay-render-request', this.auto_open_league_overlay_league_id);
              }
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() //
    // So leagues are displayed in same order as game list for consistency's sake
    //
  }, {
    key: "sortLeagues",
    value: function sortLeagues() {
      var _this4 = this;
      var superArray = [];
      try {
        this.leagues.forEach(function (l) {
          var gm = _this4.app.modules.returnModuleByName(l.game);
          //This will filter out any games we previously deleted
          if (gm) {
            superArray.push([l.admin, gm.categories, l]);
          }
        });
        superArray.sort(function (a, b) {
          //Push community leagues to the top
          if (a[0] && !b[0]) {
            return -1;
          }
          if (!a[0] && b[0]) {
            return 1;
          }

          //Sort by game categories
          if (a[1] > b[1]) {
            return 1;
          }
          if (a[1] < b[1]) {
            return -1;
          }
          return 0;
        });
        this.leagues = [];
        for (var i = 0; i < superArray.length; i++) {
          this.leagues.push(superArray[i][2]);
        }
      } catch (err) {
        console.error('League sort Error:', err);
      }
    }

    //////////////////////////
    // Rendering Components //
    //////////////////////////
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.main = new LeagueMain(this.app, this);
              this.header = new SaitoHeader(this.app, this);
              _context3.n = 1;
              return this.header.initialize(this.app);
            case 1:
              this.addComponent(this.main);
              this.addComponent(this.header);
              _context3.n = 2;
              return _superPropGet(League, "render", this, 3)([this.app, this]);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "canRenderInto",
    value: function canRenderInto(qs) {
      // RedSquare ordered mount for Leaderboard
      if (qs == '.redsquare-leaderboard') {
        return true;
      }
      return false;
    }
  }, {
    key: "renderInto",
    value: function renderInto(qs) {
      if (qs == '.redsquare-leaderboard') {
        if (!this.renderIntos[qs]) {
          this.renderIntos[qs] = [];
          this.renderIntos[qs].push(new LeagueRankings(this.app, this, qs));
        }
        this.styles = ['/league/style.css', '/arcade/style.css'];
        this.attachStyleSheets();
        this.renderIntos[qs].forEach(function (comp) {
          comp.render();
        });
      }
    }
  }, {
    key: "validateID",
    value: function validateID(league_id) {
      if (/^[a-z0-9]*$/.test(league_id)) {
        return league_id;
      }
      return '';
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, peer, service) {
        var _this5 = this;
        var league_self, league_id, sql, _this$app$modules$ret, _this$app$options, am_name, _loop, _ret, i, league_list;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              //
              // add remote leagues
              //
              league_self = this;
              if (!(service.service === 'league')) {
                _context7.n = 7;
                break;
              }
              league_id = this.validateID(app.browser.returnURLParameter('league_id'));
              if (!this.browser_active) {
                _context7.n = 1;
                break;
              }
              if (this.debug) {
                console.debug('Load all leagues');
              }
              sql = "SELECT *\n               FROM leagues\n               WHERE status = 'public'\n                 AND deleted = 0";
              _context7.n = 6;
              break;
            case 1:
              // If in a game module, just get the most up-to-date rankings
              am_name = (_this$app$modules$ret = this.app.modules.returnActiveModule()) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.name;
              if (!am_name) {
                _context7.n = 5;
                break;
              }
              _loop = /*#__PURE__*/_regenerator().m(function _loop(i) {
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      if (!(_this5.leagues[i].game == am_name)) {
                        _context4.n = 1;
                        break;
                      }
                      _this5.fetchLeagueLeaderboard(_this5.leagues[i].id, function () {
                        console.info('Update league info for curent game:', _this5.leagues[i]);
                        _this5.app.connection.emit('league-leaderboard-loaded', _this5.leagues[i].game, _this5.leagues[i].players);
                      });
                      return _context4.a(2, {
                        v: void 0
                      });
                    case 1:
                      return _context4.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 2:
              if (!(i < this.leagues.length)) {
                _context7.n = 5;
                break;
              }
              return _context7.d(_regeneratorValues(_loop(i)), 3);
            case 3:
              _ret = _context7.v;
              if (!_ret) {
                _context7.n = 4;
                break;
              }
              return _context7.a(2, _ret.v);
            case 4:
              i++;
              _context7.n = 2;
              break;
            case 5:
              league_list = '';
              if ((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && (_this$app$options = _this$app$options.league) !== null && _this$app$options !== void 0 && _this$app$options.leagues) {
                league_list = this.app.options.league.leagues.map(function (x) {
                  return "'".concat(x, "'");
                }).join(', ');
              }
              if (league_id && !league_list.includes(league_id)) {
                if (league_list) {
                  league_list += ", '".concat(league_id, "'");
                } else {
                  league_list = "'".concat(league_id, "'");
                }
              }
              if (this.auto_open_league_overlay_league_id && !league_list.includes(this.auto_open_league_overlay_league_id)) {
                if (league_list) {
                  league_list += ", '".concat(this.auto_open_league_overlay_league_id, "'");
                } else {
                  league_list = "'".concat(this.auto_open_league_overlay_league_id, "'");
                }
              }
              if (this.debug) {
                console.debug('Load my leagues: ' + league_list);
              }

              //sql = `SELECT * FROM leagues WHERE id IN (${league_list})`;
              sql = "SELECT *\n               FROM leagues\n               WHERE (admin = '' OR id IN (".concat(league_list, "))\n                 AND deleted = 0");
            case 6:
              //
              // load any requested league we may not have in options file
              // or refresh any league data that has changed
              //
              this.sendPeerDatabaseRequestWithFilter('League', sql, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
                  var _iterator, _step, league, jlo, _t;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.p = _context5.n) {
                      case 0:
                        if (!(res !== null && res !== void 0 && res.rows)) {
                          _context5.n = 9;
                          break;
                        }
                        _iterator = _createForOfIteratorHelper(res.rows);
                        _context5.p = 1;
                        _iterator.s();
                      case 2:
                        if ((_step = _iterator.n()).done) {
                          _context5.n = 6;
                          break;
                        }
                        league = _step.value;
                        if (!league.deleted) {
                          _context5.n = 4;
                          break;
                        }
                        _context5.n = 3;
                        return league_self.removeLeague(league.id);
                      case 3:
                        _context5.n = 5;
                        break;
                      case 4:
                        _context5.n = 5;
                        return league_self.updateLeague(league);
                      case 5:
                        _context5.n = 2;
                        break;
                      case 6:
                        _context5.n = 8;
                        break;
                      case 7:
                        _context5.p = 7;
                        _t = _context5.v;
                        _iterator.e(_t);
                      case 8:
                        _context5.p = 8;
                        _iterator.f();
                        return _context5.f(8);
                      case 9:
                        league_self.sortLeagues();
                        app.connection.emit('leagues-render-request');
                        app.connection.emit('league-rankings-render-request');

                        //
                        // league join league
                        //
                        if (league_id) {
                          console.info('Joining league: ', league_id);
                          jlo = new JoinLeagueOverlay(app, league_self, league_id);
                          jlo.render();
                        }

                        //
                        // Viewing a league/game page
                        //
                        if (league_self.auto_open_league_overlay_league_id) {
                          app.connection.emit('league-overlay-render-request', _this5.auto_open_league_overlay_league_id);
                        }
                      case 10:
                        return _context5.a(2);
                    }
                  }, _callee4, null, [[1, 7, 8, 9]]);
                }));
                return function (_x6) {
                  return _ref2.apply(this, arguments);
                };
              }(), function (p) {
                if (p.publicKey == peer.publicKey) {
                  return 1;
                }
                return 0;
              });

              //
              // fetch updated rankings
              //

              setTimeout(function () {
                var league_list = _this5.leagues.map(function (x) {
                  return "'".concat(x.id, "'");
                }).join(', ');
                var league = null;
                var rank, myPlayerStats;
                var cutoff = new Date().getTime() - 3 * 24 * 60 * 60 * 1000;
                _this5.sendPeerDatabaseRequestWithFilter('League', "SELECT *\n           FROM players\n           WHERE deleted = 0\n             AND games_finished > 0\n             AND league_id IN (".concat(league_list, ")\n           ORDER BY league_id, score DESC, games_won DESC, games_tied DESC, games_finished DESC"), /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
                    var _league_id, _iterator2, _step2, p, _t2;
                    return _regenerator().w(function (_context6) {
                      while (1) switch (_context6.p = _context6.n) {
                        case 0:
                          if (!(res !== null && res !== void 0 && res.rows)) {
                            _context6.n = 14;
                            break;
                          }
                          _league_id = 0;
                          _iterator2 = _createForOfIteratorHelper(res.rows);
                          _context6.p = 1;
                          _iterator2.s();
                        case 2:
                          if ((_step2 = _iterator2.n()).done) {
                            _context6.n = 9;
                            break;
                          }
                          p = _step2.value;
                          if (!(p.league_id !== _league_id)) {
                            _context6.n = 4;
                            break;
                          }
                          _league_id = p.league_id;

                          //Add me to bottom of list if I haven't played any games
                          if (!myPlayerStats) {
                            _context6.n = 3;
                            break;
                          }
                          _context6.n = 3;
                          return _this5.addLeaguePlayer(_league_id, myPlayerStats);
                        case 3:
                          league = league_self.returnLeague(_league_id);
                          league.players = [];
                          league.rank = -1;
                          rank = 0;
                          myPlayerStats = null;
                        //league.timestamp = new Date().getTime();
                        case 4:
                          if (!((p.games_finished == 0 && p.score !== league.default_score || p.timestamp < cutoff) && p.publickey !== _this5.publicKey && !league.admin)) {
                            _context6.n = 5;
                            break;
                          }
                          return _context6.a(3, 8);
                        case 5:
                          //
                          // Count how many people are ranked above me in the leaderboard
                          //
                          rank++;
                          if (!(p.publickey == _this5.publicKey)) {
                            _context6.n = 7;
                            break;
                          }
                          if (!(p.games_finished > 0)) {
                            _context6.n = 6;
                            break;
                          }
                          league.rank = rank;
                          _context6.n = 7;
                          break;
                        case 6:
                          league.rank = 0;
                          myPlayerStats = p;
                          return _context6.a(3, 8);
                        case 7:
                          _context6.n = 8;
                          return _this5.addLeaguePlayer(_league_id, p);
                        case 8:
                          _context6.n = 2;
                          break;
                        case 9:
                          _context6.n = 11;
                          break;
                        case 10:
                          _context6.p = 10;
                          _t2 = _context6.v;
                          _iterator2.e(_t2);
                        case 11:
                          _context6.p = 11;
                          _iterator2.f();
                          return _context6.f(11);
                        case 12:
                          if (!myPlayerStats) {
                            _context6.n = 13;
                            break;
                          }
                          _context6.n = 13;
                          return _this5.addLeaguePlayer(_league_id, myPlayerStats);
                        case 13:
                          league_self.leagues.forEach(function (l) {
                            l.numPlayers = l.players.length;
                          });

                          //Refresh UI
                          app.connection.emit('leagues-render-request');
                          app.connection.emit('league-rankings-render-request');
                          app.connection.emit('league-data-loaded');

                          //Save locally
                          _this5.saveLeagues();
                        case 14:
                          return _context6.a(2);
                      }
                    }, _callee5, null, [[1, 10, 11, 12]]);
                  }));
                  return function (_x7) {
                    return _ref3.apply(this, arguments);
                  };
                }(), function (p) {
                  if (p.hasService('league')) {
                    return 1;
                  }
                  return 0;
                });
              }, 5000);
            case 7:
              return _context7.a(2);
          }
        }, _callee6, this);
      }));
      function onPeerServiceUp(_x3, _x4, _x5) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(blk, tx, conf) {
        var txmsg, _t3;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (!(Number(conf) != 0)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              _context8.p = 1;
              if (!(this.app.BROWSER && !tx.isTo(this.publicKey))) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              if (!this.hasSeenTransaction(tx, blk)) {
                _context8.n = 3;
                break;
              }
              return _context8.a(2);
            case 3:
              txmsg = tx.returnMessage();
              if (this.debug) {
                console.debug('LEAGUE [onConfirmation]: ' + txmsg.request);
              }
              if (!(txmsg.request === 'league create')) {
                _context8.n = 5;
                break;
              }
              _context8.n = 4;
              return this.receiveCreateTransaction(blk, tx, conf);
            case 4:
              _context8.n = 22;
              break;
            case 5:
              if (!(txmsg.request === 'league join')) {
                _context8.n = 7;
                break;
              }
              _context8.n = 6;
              return this.receiveJoinTransaction(blk, tx, conf);
            case 6:
              _context8.n = 22;
              break;
            case 7:
              if (!(txmsg.request === 'league quit')) {
                _context8.n = 9;
                break;
              }
              _context8.n = 8;
              return this.receiveQuitTransaction(blk, tx, conf);
            case 8:
              _context8.n = 22;
              break;
            case 9:
              if (!(txmsg.request === 'league remove')) {
                _context8.n = 11;
                break;
              }
              _context8.n = 10;
              return this.receiveRemoveTransaction(blk, tx, conf);
            case 10:
              _context8.n = 22;
              break;
            case 11:
              if (!(txmsg.request === 'league update')) {
                _context8.n = 13;
                break;
              }
              _context8.n = 12;
              return this.receiveUpdateTransaction(blk, tx, conf);
            case 12:
              _context8.n = 22;
              break;
            case 13:
              if (!(txmsg.request === 'league update player')) {
                _context8.n = 15;
                break;
              }
              _context8.n = 14;
              return this.receiveUpdatePlayerTransaction(blk, tx, conf);
            case 14:
              _context8.n = 22;
              break;
            case 15:
              if (!(txmsg.request === 'gameover' || txmsg.request === 'roundover')) {
                _context8.n = 17;
                break;
              }
              _context8.n = 16;
              return this.receiveGameOverTransaction(blk, tx, conf);
            case 16:
              _context8.n = 22;
              break;
            case 17:
              if (!(txmsg.request === 'accept')) {
                _context8.n = 19;
                break;
              }
              console.log('League processing game accept');
              _context8.n = 18;
              return this.receiveAcceptTransaction(blk, tx, conf);
            case 18:
              _context8.n = 22;
              break;
            case 19:
              if (!(txmsg.request === 'launch singleplayer')) {
                _context8.n = 21;
                break;
              }
              _context8.n = 20;
              return this.receiveLaunchSinglePlayerTransaction(blk, tx, conf);
            case 20:
              _context8.n = 22;
              break;
            case 21:
              return _context8.a(2);
            case 22:
              if (this.app.BROWSER) {
                this.saveLeagues();
                this.sortLeagues();
                this.app.connection.emit('leagues-render-request');
                this.app.connection.emit('league-rankings-render-request');
              }
              _context8.n = 24;
              break;
            case 23:
              _context8.p = 23;
              _t3 = _context8.v;
              console.error('ERROR in league onConfirmation: ' + _t3);
            case 24:
              return _context8.a(2);
          }
        }, _callee7, this, [[1, 23]]);
      }));
      function onConfirmation(_x8, _x9, _x0) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (modname == 'League') {
        return 1;
      }
      if (modname == 'Arcade') {
        return 1;
      }
      for (var i = 0; i < this.leagues.length; i++) {
        if (this.leagues[i].game === modname) {
          return 1;
        }
      }
      return 0;
    }
  }, {
    key: "loadLeagues",
    value: function () {
      var _loadLeagues = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var league_self, _iterator3, _step3, lid, value, _league_self$app$modu, league, sqlResults, _iterator4, _step4, _league, _t4, _t5;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              league_self = this;
              if (!this.app.BROWSER) {
                _context9.n = 12;
                break;
              }
              if (!this.app.options.league.leagues) {
                _context9.n = 10;
                break;
              }
              if (this.debug) {
                console.debug('Locally stored leagues:', JSON.parse(JSON.stringify(this.app.options.league)));
              }
              _iterator3 = _createForOfIteratorHelper(this.app.options.league.leagues);
              _context9.p = 1;
              _iterator3.s();
            case 2:
              if ((_step3 = _iterator3.n()).done) {
                _context9.n = 6;
                break;
              }
              lid = _step3.value;
              _context9.n = 3;
              return this.app.storage.getLocalForageItem("league_".concat(lid));
            case 3:
              value = _context9.v;
              if (!value) {
                _context9.n = 5;
                break;
              }
              _context9.n = 4;
              return league_self.updateLeague(value);
            case 4:
              league = league_self.returnLeague(lid); //Make sure we get these data right!
              league.players = value.players;
              league.rank = value.rank;
              league.numPlayers = value.numPlayers;
              if (league.game === ((_league_self$app$modu = league_self.app.modules.returnActiveModule()) === null || _league_self$app$modu === void 0 ? void 0 : _league_self$app$modu.name)) {
                console.debug('Local version of this game league: ', JSON.parse(JSON.stringify(league)));
              }
            case 5:
              _context9.n = 2;
              break;
            case 6:
              _context9.n = 8;
              break;
            case 7:
              _context9.p = 7;
              _t4 = _context9.v;
              _iterator3.e(_t4);
            case 8:
              _context9.p = 8;
              _iterator3.f();
              return _context9.f(8);
            case 9:
              league_self.sortLeagues();
              //Render initial UI based on what we have saved
              league_self.app.connection.emit('leagues-render-request'); // league/ main
              league_self.app.connection.emit('league-rankings-render-request'); // sidebar league list
              league_self.app.connection.emit('league-finished-loading');
              _context9.n = 11;
              break;
            case 10:
              this.app.options.league.leagues = [];
            case 11:
              delete this.app.options.league.watch_list;
              _context9.n = 20;
              break;
            case 12:
              _context9.n = 13;
              return this.app.storage.queryDatabase("SELECT *\n         FROM leagues\n         WHERE deleted = 0", [], 'league');
            case 13:
              sqlResults = _context9.v;
              if (!sqlResults) {
                _context9.n = 20;
                break;
              }
              _iterator4 = _createForOfIteratorHelper(sqlResults);
              _context9.p = 14;
              _iterator4.s();
            case 15:
              if ((_step4 = _iterator4.n()).done) {
                _context9.n = 17;
                break;
              }
              _league = _step4.value;
              _context9.n = 16;
              return league_self.updateLeague(_league);
            case 16:
              _context9.n = 15;
              break;
            case 17:
              _context9.n = 19;
              break;
            case 18:
              _context9.p = 18;
              _t5 = _context9.v;
              _iterator4.e(_t5);
            case 19:
              _context9.p = 19;
              _iterator4.f();
              return _context9.f(19);
            case 20:
              return _context9.a(2);
          }
        }, _callee8, this, [[14, 18, 19, 20], [1, 7, 8, 9]]);
      }));
      function loadLeagues() {
        return _loadLeagues.apply(this, arguments);
      }
      return loadLeagues;
    }()
    /**
     * We only store the leagues we are a member of.
     * League id -> app.options, full league data in localForage
     *
     * maybe this should be async...
     */
  }, {
    key: "saveLeagues",
    value: function saveLeagues() {
      if (!this.app.BROWSER) {
        return;
      }
      var league_self = this;
      var leagues_to_save = [];
      var cnt = 0;
      var _iterator5 = _createForOfIteratorHelper(this.leagues),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var league = _step5.value;
          if (league.rank >= 0 || league.admin === this.publicKey) {
            //let newLeague = JSON.parse(JSON.stringify(league));
            //delete newLeague.players;
            leagues_to_save.push(league.id);
            this.app.storage.setLocalForageItem("league_".concat(league.id), league);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this.app.options.league.leagues = leagues_to_save;
      delete this.app.options.league.watch_list;
      if (this.debug) {
        console.info('Save Leagues:');
        console.debug(JSON.parse(JSON.stringify(this.app.options.league)), JSON.parse(JSON.stringify(this.leagues)));
      }
      this.app.storage.saveOptions();
    }

    /////////////////////
    // create a league //
    /////////////////////
  }, {
    key: "createCreateTransaction",
    value: function () {
      var _createCreateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var obj,
          newtx,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              obj = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : null;
              if (!(obj == null)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, null);
            case 1:
              _context0.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 2:
              newtx = _context0.v;
              newtx.msg = this.validateLeague(obj);
              newtx.msg.module = 'League';
              newtx.msg.request = 'league create';
              newtx.addTo(this.publicKey);
              _context0.n = 3;
              return newtx.sign();
            case 3:
              return _context0.a(2, newtx);
          }
        }, _callee9, this);
      }));
      function createCreateTransaction() {
        return _createCreateTransaction.apply(this, arguments);
      }
      return createCreateTransaction;
    }()
  }, {
    key: "receiveCreateTransaction",
    value: function () {
      var _receiveCreateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(blk, tx, conf) {
        var txmsg, obj;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              txmsg = tx.returnMessage();
              obj = this.validateLeague(txmsg);
              obj.id = tx.signature;
              _context1.n = 1;
              return this.addLeague(obj);
            case 1:
              return _context1.a(2);
          }
        }, _callee0, this);
      }));
      function receiveCreateTransaction(_x1, _x10, _x11) {
        return _receiveCreateTransaction.apply(this, arguments);
      }
      return receiveCreateTransaction;
    }()
  }, {
    key: "addressToAll",
    value: function addressToAll(tx, league_id) {
      tx.addTo(this.publicKey);
      var league = this.returnLeague(league_id);
      if (!(league !== null && league !== void 0 && league.admin)) {
        return tx;
      }
      tx.addTo(league.admin);
      var _iterator6 = _createForOfIteratorHelper(league.players),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var p = _step6.value;
          tx.addTo(p.publicKey);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return tx;
    }

    ///////////////////
    // join a league //
    ///////////////////
  }, {
    key: "createJoinTransaction",
    value: function () {
      var _createJoinTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var league_id,
          email,
          newtx,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              league_id = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : '';
              email = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : '';
              _context10.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context10.v;
              newtx = this.addressToAll(newtx, league_id);
              newtx.msg = {
                module: 'League',
                league_id: league_id,
                request: 'league join'
              };
              if (email) {
                newtx.msg.email = email;
              }
              _context10.n = 2;
              return newtx.sign();
            case 2:
              return _context10.a(2, newtx);
          }
        }, _callee1, this);
      }));
      function createJoinTransaction() {
        return _createJoinTransaction.apply(this, arguments);
      }
      return createJoinTransaction;
    }()
  }, {
    key: "receiveJoinTransaction",
    value: function () {
      var _receiveJoinTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(blk, tx, conf) {
        var _this6 = this;
        var txmsg, params, league;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              txmsg = tx.returnMessage();
              params = {
                publicKey: tx.from[0].publicKey,
                email: txmsg.email || '',
                ts: parseInt(tx.timestamp)
              };
              _context11.n = 1;
              return this.addLeaguePlayer(txmsg.league_id, params);
            case 1:
              if (!(this.publicKey === tx.from[0].publicKey)) {
                _context11.n = 2;
                break;
              }
              this.fetchLeagueLeaderboard(txmsg.league_id, function () {
                _this6.app.connection.emit('join-league-success');
              });
              return _context11.a(2);
            case 2:
              league = this.returnLeague(txmsg.league_id);
              if (this.publicKey === league.admin) {
                this.fetchLeagueLeaderboard(txmsg.league_id, function () {
                  siteMessage('New league member', 2500);
                });
              }
            case 3:
              return _context11.a(2);
          }
        }, _callee10, this);
      }));
      function receiveJoinTransaction(_x12, _x13, _x14) {
        return _receiveJoinTransaction.apply(this, arguments);
      }
      return receiveJoinTransaction;
    }()
  }, {
    key: "createUpdateTransaction",
    value: function () {
      var _createUpdateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(league_id, new_data) {
        var field,
          newtx,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              field = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : 'description';
              _context12.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context12.v;
              newtx = this.addressToAll(newtx, league_id);
              newtx.msg = {
                module: 'League',
                request: 'league update',
                league_id: league_id,
                new_data: new_data,
                field: field
              };
              _context12.n = 2;
              return newtx.sign();
            case 2:
              return _context12.a(2, newtx);
          }
        }, _callee11, this);
      }));
      function createUpdateTransaction(_x15, _x16) {
        return _createUpdateTransaction.apply(this, arguments);
      }
      return createUpdateTransaction;
    }()
  }, {
    key: "receiveUpdateTransaction",
    value: function () {
      var _receiveUpdateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(blk, tx, conf) {
        var txmsg, league_id, new_data, field, league, sql, params;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              txmsg = tx.returnMessage();
              league_id = txmsg.league_id;
              new_data = txmsg.new_data;
              field = txmsg.field;
              if (!(field !== 'description' && field !== 'contact')) {
                _context13.n = 1;
                break;
              }
              console.error('League Update Error: Unknown SQL field');
              return _context13.a(2);
            case 1:
              league = this.returnLeague(league_id);
              if (league) {
                league[field] = new_data;
              }
              sql = "UPDATE OR IGNORE leagues\n               SET ".concat(field, " = $data\n               WHERE id = $id");
              params = {
                $id: league_id,
                $data: new_data
              };
              _context13.n = 2;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 2:
              return _context13.a(2);
          }
        }, _callee12, this);
      }));
      function receiveUpdateTransaction(_x17, _x18, _x19) {
        return _receiveUpdateTransaction.apply(this, arguments);
      }
      return receiveUpdateTransaction;
    }()
  }, {
    key: "createUpdatePlayerTransaction",
    value: function () {
      var _createUpdatePlayerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(league_id, publicKey, new_data) {
        var field,
          newtx,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              field = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : 'email';
              _context14.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context14.v;
              newtx.addTo(this.publicKey);
              newtx.addTo(publicKey);
              newtx.msg = {
                module: 'League',
                request: 'league update player',
                league_id: league_id,
                publicKey: publicKey,
                new_data: new_data,
                field: field
              };
              _context14.n = 2;
              return newtx.sign();
            case 2:
              return _context14.a(2, newtx);
          }
        }, _callee13, this);
      }));
      function createUpdatePlayerTransaction(_x20, _x21, _x22) {
        return _createUpdatePlayerTransaction.apply(this, arguments);
      }
      return createUpdatePlayerTransaction;
    }()
  }, {
    key: "receiveUpdatePlayerTransaction",
    value: function () {
      var _receiveUpdatePlayerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(blk, tx, conf) {
        var _this7 = this;
        var txmsg, league_id, publicKey, new_data, field, league, sql, params;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              txmsg = tx.returnMessage();
              league_id = txmsg.league_id;
              publicKey = txmsg.publicKey;
              new_data = txmsg.new_data;
              field = txmsg.field;
              if (!(field !== 'email' && field !== 'score')) {
                _context15.n = 1;
                break;
              }
              console.error('League Update Error: Unknown SQL field');
              return _context15.a(2);
            case 1:
              league = this.returnLeague(league_id);
              if (league) {
                league[field] = new_data;
              }

              //My data was updated...
              if (this.publicKey === publicKey) {
                setTimeout(function () {
                  _this7.fetchLeagueLeaderboard(league_id, function () {
                    if (field == 'email' && new_data) {
                      siteMessage("".concat(league.name, " membership approved"), 2500);
                    } else if (field == 'score') {
                      siteMessage("".concat(league.name, " score updated"), 2500);
                    }
                  });
                }, 1000);
              }
              sql = "UPDATE OR IGNORE players\n               SET ".concat(field, " = $data\n               WHERE league_id = $league_id\n                 AND publickey = $publickey");
              params = {
                $data: new_data,
                $league_id: league_id,
                $publickey: publicKey
              };
              _context15.n = 2;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 2:
              return _context15.a(2);
          }
        }, _callee14, this);
      }));
      function receiveUpdatePlayerTransaction(_x23, _x24, _x25) {
        return _receiveUpdatePlayerTransaction.apply(this, arguments);
      }
      return receiveUpdatePlayerTransaction;
    }() ///////////////////
    // quit a league //
    ///////////////////
  }, {
    key: "createQuitTransaction",
    value: function () {
      var _createQuitTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(league_id) {
        var publicKey,
          newtx,
          _args16 = arguments;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              publicKey = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : null;
              _context16.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context16.v;
              newtx = this.addressToAll(newtx, league_id);
              publicKey = publicKey || this.publicKey;
              newtx.msg = {
                module: 'League',
                request: 'league quit',
                league_id: league_id,
                publicKey: publicKey
              };
              _context16.n = 2;
              return newtx.sign();
            case 2:
              return _context16.a(2, newtx);
          }
        }, _callee15, this);
      }));
      function createQuitTransaction(_x26) {
        return _createQuitTransaction.apply(this, arguments);
      }
      return createQuitTransaction;
    }()
  }, {
    key: "receiveQuitTransaction",
    value: function () {
      var _receiveQuitTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(blk, tx, conf) {
        var txmsg, sql, params;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              txmsg = tx.returnMessage();
              sql = "UPDATE players\n               SET deleted = 1\n               WHERE league_id = $league\n                 AND publickey = $publickey";
              params = {
                $league: txmsg.league_id,
                $publickey: txmsg.publicKey
              };
              _context17.n = 1;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 1:
              _context17.n = 2;
              return this.removeLeaguePlayer(txmsg.league_id, txmsg.publicKey);
            case 2:
              return _context17.a(2);
          }
        }, _callee16, this);
      }));
      function receiveQuitTransaction(_x27, _x28, _x29) {
        return _receiveQuitTransaction.apply(this, arguments);
      }
      return receiveQuitTransaction;
    }() /////////////////////
    // remove a league //
    /////////////////////
  }, {
    key: "createRemoveTransaction",
    value: function () {
      var _createRemoveTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(league_id) {
        var newtx;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _context18.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context18.v;
              newtx = this.addressToAll(newtx, league_id);
              newtx.msg = {
                module: 'League',
                request: 'league remove',
                league_id: league_id
              };
              if ((this === null || this === void 0 ? void 0 : this.sudo) == league_id) {
                newtx.msg['sudo'] = this.publicKey;
              }
              _context18.n = 2;
              return newtx.sign();
            case 2:
              return _context18.a(2, newtx);
          }
        }, _callee17, this);
      }));
      function createRemoveTransaction(_x30) {
        return _createRemoveTransaction.apply(this, arguments);
      }
      return createRemoveTransaction;
    }()
  }, {
    key: "receiveRemoveTransaction",
    value: function () {
      var _receiveRemoveTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(blk, tx, conf) {
        var txmsg, sql1, params1, result, sql2, params2;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              txmsg = tx.returnMessage();
              if (txmsg !== null && txmsg !== void 0 && txmsg.sudo && txmsg.sudo === tx.from[0].publicKey) {
                sql1 = "UPDATE leagues\n            SET deleted = 1\n            WHERE id = $id";
                params1 = {
                  $id: txmsg.league_id
                };
              } else {
                sql1 = "UPDATE leagues\n                  SET deleted = 1\n                  WHERE id = $id\n                    AND admin = $admin";
                params1 = {
                  $id: txmsg.league_id,
                  $admin: tx.from[0].publicKey
                };
              }
              _context19.n = 1;
              return this.app.storage.runDatabase(sql1, params1, 'league');
            case 1:
              result = _context19.v;
              sql2 = "UPDATE players\n                SET deleted = 1\n                WHERE league_id = $league_id";
              params2 = {
                $league_id: txmsg.league_id
              };
              _context19.n = 2;
              return this.app.storage.runDatabase(sql2, params2, 'league');
            case 2:
              result = _context19.v;
              _context19.n = 3;
              return this.removeLeague(txmsg.league_id);
            case 3:
              return _context19.a(2);
          }
        }, _callee18, this);
      }));
      function receiveRemoveTransaction(_x31, _x32, _x33) {
        return _receiveRemoveTransaction.apply(this, arguments);
      }
      return receiveRemoveTransaction;
    }() //////////////////////////
    // gameover transaction //
    //////////////////////////
  }, {
    key: "receiveGameOverTransaction",
    value: function () {
      var _receiveGameOverTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(blk, tx, conf) {
        var _this8 = this;
        var txmsg, is_gameover, game, _txmsg$reason, _txmsg$reason2, publicKeys, relevantLeagues, _iterator7, _step7, _loop2, _t6;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              //if (app.BROWSER == 1) { return; }
              txmsg = tx.returnMessage();
              is_gameover = txmsg.request == 'gameover' ? true : false;
              game = txmsg.module; //
              // small grace period
              //
              if (!is_gameover) {
                _context21.n = 3;
                break;
              }
              if (!(txmsg.reason == 'cancellation' || (_txmsg$reason = txmsg.reason) !== null && _txmsg$reason !== void 0 && _txmsg$reason.includes('Wins:') || (_txmsg$reason2 = txmsg.reason) !== null && _txmsg$reason2 !== void 0 && _txmsg$reason2.includes('Scores: '))) {
                _context21.n = 1;
                break;
              }
              console.info("League: don't process game over ", txmsg.reason);
              return _context21.a(2);
            case 1:
              if (!this.finished_games.includes(txmsg.game_id)) {
                _context21.n = 2;
                break;
              }
              console.warn('League: Game over already processed');
              return _context21.a(2);
            case 2:
              this.finished_games.push(txmsg.game_id);
            case 3:
              //
              // fetch players
              //
              publicKeys = txmsg.players.split('_');
              if (Array.isArray(txmsg.winner) && txmsg.winner.length == 1) {
                txmsg.winner = txmsg.winner[0];
              }
              if (this.debug) {
                console.info("League updating player scores for end of ".concat(is_gameover ? 'game' : 'round'), publicKeys);
              }
              //
              // fetch leagues
              //
              _context21.n = 4;
              return this.getRelevantLeagues(game, txmsg === null || txmsg === void 0 ? void 0 : txmsg.league_id);
            case 4:
              relevantLeagues = _context21.v;
              if (relevantLeagues) {
                _context21.n = 5;
                break;
              }
              console.warn('League [receiveGameOver]: No relevant leagues to update');
              return _context21.a(2);
            case 5:
              //
              // update database
              //
              _iterator7 = _createForOfIteratorHelper(relevantLeagues);
              _context21.p = 6;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2() {
                var leag, myScore, myRank;
                return _regenerator().w(function (_context20) {
                  while (1) switch (_context20.n) {
                    case 0:
                      leag = _step7.value;
                      myScore = leag.score;
                      myRank = leag.rank; //
                      // update rankings (ELO)
                      //
                      if (!(leag.ranking_algorithm === 'ELO')) {
                        _context20.n = 1;
                        break;
                      }
                      _context20.n = 1;
                      return _this8.updateELORanking(publicKeys, leag, tx);
                    case 1:
                      if (!(leag.ranking_algorithm === 'EXP')) {
                        _context20.n = 2;
                        break;
                      }
                      _context20.n = 2;
                      return _this8.updateEXPRanking(publicKeys, leag, txmsg);
                    case 2:
                      if (!(leag.ranking_algorithm === 'HSC')) {
                        _context20.n = 3;
                        break;
                      }
                      _context20.n = 3;
                      return _this8.updateHighScore(publicKeys, leag, txmsg);
                    case 3:
                      if (_this8.app.BROWSER) {
                        console.info('League [receiveGameOver]: update league on game over');
                        console.debug(JSON.parse(JSON.stringify(leag.players)), myScore, myRank);
                        _this8.fetchLeagueLeaderboard(leag.id, function () {
                          if (myRank <= 0 && leag.rank > 0) {
                            if (is_gameover) {
                              siteMessage("You are now ranked ".concat(leag.rank, " on the ").concat(leag.name, " leaderboard"));
                            }
                          } else {
                            var point_message = '';
                            if (leag.ranking_algorithm === 'ELO' && leag.score != myScore) {
                              if (leag.score > myScore) {
                                point_message = "gained ".concat(leag.score - myScore, " points");
                              } else {
                                point_message = "lost ".concat(myScore - leag.score, " points");
                              }
                            } else if (leag.ranking_algorithm === 'HSC') {
                              if (leag.score > myScore) {
                                point_message = "set a new personal best of ".concat(leag.score);
                              }
                            }
                            var rank_message = '';
                            if (myRank > leag.rank) {
                              rank_message = "jumped ".concat(myRank - leag.rank, " place").concat(myRank - leag.rank > 1 ? 's' : '', " on the leaderboard");
                            } else if (myRank < leag.rank) {
                              rank_message = "dropped ".concat(leag.rank - myRank, " place").concat(leag.rank - myRank > 1 ? 's' : '', " on the leaderboard");
                            }
                            if (is_gameover) {
                              if (point_message && rank_message) {
                                siteMessage("".concat(leag.name, ": You ").concat(point_message, " and ").concat(rank_message));
                              } else if (point_message || rank_message) {
                                siteMessage("".concat(leag.name, ": You ").concat(point_message).concat(rank_message));
                              }
                            }
                          }
                          console.info('LEAGUE: My previous score and rank:', myScore, myRank, 'LEAGUE: My new score and rank: ', leag.score, leag.rank);
                        });
                      }
                    case 4:
                      return _context20.a(2);
                  }
                }, _loop2);
              });
              _iterator7.s();
            case 7:
              if ((_step7 = _iterator7.n()).done) {
                _context21.n = 9;
                break;
              }
              return _context21.d(_regeneratorValues(_loop2()), 8);
            case 8:
              _context21.n = 7;
              break;
            case 9:
              _context21.n = 11;
              break;
            case 10:
              _context21.p = 10;
              _t6 = _context21.v;
              _iterator7.e(_t6);
            case 11:
              _context21.p = 11;
              _iterator7.f();
              return _context21.f(11);
            case 12:
              return _context21.a(2);
          }
        }, _callee19, this, [[6, 10, 11, 12]]);
      }));
      function receiveGameOverTransaction(_x34, _x35, _x36) {
        return _receiveGameOverTransaction.apply(this, arguments);
      }
      return receiveGameOverTransaction;
    }() ////////////////////////
    // accept transaction //
    ////////////////////////
    //
    // inserts player into public league if one exists
    //
  }, {
    key: "receiveLaunchSinglePlayerTransaction",
    value: function () {
      var _receiveLaunchSinglePlayerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(blk, tx, conf) {
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              _context22.n = 1;
              return this.receiveAcceptTransaction(blk, tx, conf);
            case 1:
              return _context22.a(2);
          }
        }, _callee20, this);
      }));
      function receiveLaunchSinglePlayerTransaction(_x37, _x38, _x39) {
        return _receiveLaunchSinglePlayerTransaction.apply(this, arguments);
      }
      return receiveLaunchSinglePlayerTransaction;
    }()
  }, {
    key: "receiveAcceptTransaction",
    value: function () {
      var _receiveAcceptTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(blk, tx, conf) {
        var _txmsg$options;
        var txmsg, relevantLeagues, _txmsg$options2, publicKeys, i, _iterator8, _step8, leag, _iterator9, _step9, publicKey, _t7, _t8;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.p = _context23.n) {
            case 0:
              txmsg = tx.returnMessage(); //if (this.debug) {
              console.debug("League processing game start of ".concat(txmsg.game, "!"));
              //}

              //if (this.app.BROWSER){ return; }
              _context23.n = 1;
              return this.getRelevantLeagues(txmsg.game, txmsg === null || txmsg === void 0 || (_txmsg$options = txmsg.options) === null || _txmsg$options === void 0 ? void 0 : _txmsg$options.league_id);
            case 1:
              relevantLeagues = _context23.v;
              if (relevantLeagues) {
                _context23.n = 2;
                break;
              }
              return _context23.a(2);
            case 2:
              if (this.debug) {
                console.debug('League [acceptGame]: ', "Specific league? ".concat(txmsg !== null && txmsg !== void 0 && (_txmsg$options2 = txmsg.options) !== null && _txmsg$options2 !== void 0 && _txmsg$options2.league_id ? txmsg.options.league_id : 'no'), JSON.parse(JSON.stringify(relevantLeagues)));
              }

              //
              // who are the players ?
              //
              publicKeys = [];
              for (i = 0; i < tx.to.length; i++) {
                if (!publicKeys.includes(tx.to[i].publicKey)) {
                  publicKeys.push(tx.to[i].publicKey);
                }
              }

              //
              // and insert if needed
              //
              _iterator8 = _createForOfIteratorHelper(relevantLeagues);
              _context23.p = 3;
              _iterator8.s();
            case 4:
              if ((_step8 = _iterator8.n()).done) {
                _context23.n = 13;
                break;
              }
              leag = _step8.value;
              _iterator9 = _createForOfIteratorHelper(publicKeys);
              _context23.p = 5;
              _iterator9.s();
            case 6:
              if ((_step9 = _iterator9.n()).done) {
                _context23.n = 9;
                break;
              }
              publicKey = _step9.value;
              if (leag.admin) {
                _context23.n = 7;
                break;
              }
              _context23.n = 7;
              return this.addLeaguePlayer(leag.id, {
                publicKey: publicKey
              });
            case 7:
              _context23.n = 8;
              return this.incrementPlayer(publicKey, leag.id, 'games_started');
            case 8:
              _context23.n = 6;
              break;
            case 9:
              _context23.n = 11;
              break;
            case 10:
              _context23.p = 10;
              _t7 = _context23.v;
              _iterator9.e(_t7);
            case 11:
              _context23.p = 11;
              _iterator9.f();
              return _context23.f(11);
            case 12:
              _context23.n = 4;
              break;
            case 13:
              _context23.n = 15;
              break;
            case 14:
              _context23.p = 14;
              _t8 = _context23.v;
              _iterator8.e(_t8);
            case 15:
              _context23.p = 15;
              _iterator8.f();
              return _context23.f(15);
            case 16:
              return _context23.a(2);
          }
        }, _callee21, this, [[5, 10, 11, 12], [3, 14, 15, 16]]);
      }));
      function receiveAcceptTransaction(_x40, _x41, _x42) {
        return _receiveAcceptTransaction.apply(this, arguments);
      }
      return receiveAcceptTransaction;
    }() /////////////////////
    /////////////////////
  }, {
    key: "getRelevantLeagues",
    value: function () {
      var _getRelevantLeagues = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(game) {
        var target_league,
          localLeagues,
          _args24 = arguments;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              target_league = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : '';
              /*let sql = `SELECT *
                         FROM leagues
                         WHERE game = $game
                           AND (admin = "" OR id = $target)
                           AND deleted = 0`;
              let params = { $game: game, $target: target_league };
              let sqlResults = await this.app.storage.queryDatabase(sql, params, 'league');
              */
              localLeagues = this.leagues.filter(function (l) {
                if (l.game === game) {
                  if (!l.admin || l.id == target_league) {
                    return true;
                  }
                }
                return false;
              });
              return _context24.a(2, /*sqlResults ||*/localLeagues);
          }
        }, _callee22, this);
      }));
      function getRelevantLeagues(_x43) {
        return _getRelevantLeagues.apply(this, arguments);
      }
      return getRelevantLeagues;
    }()
  }, {
    key: "getPlayersFromLeague",
    value: function () {
      var _getPlayersFromLeague = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(league_id, players) {
        var sql2, _iterator0, _step0, pk, sqlResults, league, localStats;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              sql2 = "SELECT *\n                FROM players\n                WHERE league_id = ?\n                  AND publickey IN (";
              _iterator0 = _createForOfIteratorHelper(players);
              try {
                for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                  pk = _step0.value;
                  sql2 += "'".concat(pk, "', ");
                }
              } catch (err) {
                _iterator0.e(err);
              } finally {
                _iterator0.f();
              }
              sql2 = sql2.substring(0, sql2.length - 2) + ") AND deleted = 0";
              _context25.n = 1;
              return this.app.storage.queryDatabase(sql2, [league_id], 'league');
            case 1:
              sqlResults = _context25.v;
              if (sqlResults) {
                sqlResults = sqlResults.map(this.validatePlayer, this);
              }
              league = this.returnLeague(league_id);
              localStats = null;
              if (league !== null && league !== void 0 && league.players) {
                localStats = league.players.filter(function (p) {
                  return players.includes(p.publicKey);
                });
              }

              // should we look to ts value for which is the newest reault
              // Only matters on server nodes where we would have both
              return _context25.a(2, sqlResults || localStats);
          }
        }, _callee23, this);
      }));
      function getPlayersFromLeague(_x44, _x45) {
        return _getPlayersFromLeague.apply(this, arguments);
      }
      return getPlayersFromLeague;
    }() /////////////////////
    // update rankings //
    /////////////////////
  }, {
    key: "updateEXPRanking",
    value: function () {
      var _updateEXPRanking = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(publicKeys, league, txmsg) {
        var players, i, numPoints, gamekey, _i;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.n) {
            case 0:
              players = _toConsumableArray(publicKeys); //Need to refresh this each loop (since we splice below)
              //
              // winning += 5 points
              // ties    += 3 points
              // losing  += 1 point
              //
              // everyone gets a point for playing
              i = 0;
            case 1:
              if (!(i < players.length)) {
                _context26.n = 4;
                break;
              }
              _context26.n = 2;
              return this.incrementPlayer(players[i], league.id, 'score', 1);
            case 2:
              _context26.n = 3;
              return this.incrementPlayer(players[i], league.id, 'games_finished', 1);
            case 3:
              i++;
              _context26.n = 1;
              break;
            case 4:
              numPoints = txmsg.reason == 'tie' ? 2 : 4;
              gamekey = txmsg.reason == 'tie' ? 'games_tied' : 'games_won';
              _i = 0;
            case 5:
              if (!(_i < players.length)) {
                _context26.n = 8;
                break;
              }
              if (!(txmsg.winner === players[_i] || txmsg.winner.includes(players[_i]))) {
                _context26.n = 7;
                break;
              }
              _context26.n = 6;
              return this.incrementPlayer(players[_i], league.id, 'score', numPoints);
            case 6:
              _context26.n = 7;
              return this.incrementPlayer(players[_i], league.id, gamekey, 1);
            case 7:
              _i++;
              _context26.n = 5;
              break;
            case 8:
              return _context26.a(2);
          }
        }, _callee24, this);
      }));
      function updateEXPRanking(_x46, _x47, _x48) {
        return _updateEXPRanking.apply(this, arguments);
      }
      return updateEXPRanking;
    }()
  }, {
    key: "updateELORanking",
    value: function () {
      var _updateELORanking = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(players, league, tx) {
        var txmsg, playerStats, winner, loser, qsum, _iterator1, _step1, player, _i2, _winner, p, outcome, diff, _i3, _loser, _p, diff2, _t9;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.p = _context27.n) {
            case 0:
              //
              // no change for 1P games
              //
              txmsg = tx.returnMessage();
              if (!(players.length < 2)) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2);
            case 1:
              _context27.n = 2;
              return this.getPlayersFromLeague(league.id, players);
            case 2:
              playerStats = _context27.v;
              if (!(!playerStats || playerStats.length !== players.length)) {
                _context27.n = 3;
                break;
              }
              // skip out - not all players are league members
              console.warn('LEAGUE [updateELO] -- player mismatch');
              return _context27.a(2);
            case 3:
              winner = [], loser = [];
              qsum = 0;
              _iterator1 = _createForOfIteratorHelper(playerStats);
              _context27.p = 4;
              _iterator1.s();
            case 5:
              if ((_step1 = _iterator1.n()).done) {
                _context27.n = 8;
                break;
              }
              player = _step1.value;
              //Convert each players ELO rating into a logistic function
              player.q = Math.pow(10, player.score / 400);
              //Sum the denominator so that the Expected values add to 1
              qsum += player.q;

              //
              //Dynamically calculate each player's K-factor
              //
              player.k = 10;
              if ((player === null || player === void 0 ? void 0 : player.score) < 2400) {
                player.k = 20;
              }
              if ((player === null || player === void 0 ? void 0 : player.games_finished) < 30 && (player === null || player === void 0 ? void 0 : player.score) < 2300) {
                player.k = 40;
              }
              _context27.n = 6;
              return this.incrementPlayer(player.publicKey, league.id, 'games_finished');
            case 6:
              //
              //Sort into winners and losers
              //
              if (player.publicKey == txmsg.winner || txmsg.winner.includes(player.publicKey)) {
                winner.push(player);
              } else {
                loser.push(player);
              }
            case 7:
              _context27.n = 5;
              break;
            case 8:
              _context27.n = 10;
              break;
            case 9:
              _context27.p = 9;
              _t9 = _context27.v;
              _iterator1.e(_t9);
            case 10:
              _context27.p = 10;
              _iterator1.f();
              return _context27.f(10);
            case 11:
              _i2 = 0, _winner = winner;
            case 12:
              if (!(_i2 < _winner.length)) {
                _context27.n = 15;
                break;
              }
              p = _winner[_i2];
              outcome = winner.length == 1 ? 'games_won' : 'games_tied';
              _context27.n = 13;
              return this.incrementPlayer(p.publicKey, league.id, outcome);
            case 13:
              diff = p.k * (1 / winner.length - p.q / qsum);
              p.score += diff;
              _context27.n = 14;
              return this.updatePlayerScore(p, league.id);
            case 14:
              _i2++;
              _context27.n = 12;
              break;
            case 15:
              _i3 = 0, _loser = loser;
            case 16:
              if (!(_i3 < _loser.length)) {
                _context27.n = 18;
                break;
              }
              _p = _loser[_i3];
              diff2 = _p.k * _p.q / qsum;
              _p.score -= diff2;
              _context27.n = 17;
              return this.updatePlayerScore(_p, league.id);
            case 17:
              _i3++;
              _context27.n = 16;
              break;
            case 18:
              return _context27.a(2);
          }
        }, _callee25, this, [[4, 9, 10, 11]]);
      }));
      function updateELORanking(_x49, _x50, _x51) {
        return _updateELORanking.apply(this, arguments);
      }
      return updateELORanking;
    }()
  }, {
    key: "updateHighScore",
    value: function () {
      var _updateHighScore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(players, league, txmsg) {
        var playerStats, _iterator10, _step10, player, newScore, _t0;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.p = _context28.n) {
            case 0:
              if (!(players.length > 1)) {
                _context28.n = 1;
                break;
              }
              return _context28.a(2);
            case 1:
              _context28.n = 2;
              return this.getPlayersFromLeague(league.id, players);
            case 2:
              playerStats = _context28.v;
              if (!(!playerStats || playerStats.length !== players.length)) {
                _context28.n = 3;
                break;
              }
              return _context28.a(2);
            case 3:
              _iterator10 = _createForOfIteratorHelper(playerStats);
              _context28.p = 4;
              _iterator10.s();
            case 5:
              if ((_step10 = _iterator10.n()).done) {
                _context28.n = 8;
                break;
              }
              player = _step10.value;
              newScore = parseInt(txmsg.reason);
              player.score = Math.max(player.score, newScore);
              _context28.n = 6;
              return this.incrementPlayer(player.publicKey, league.id, 'games_finished');
            case 6:
              _context28.n = 7;
              return this.updatePlayerScore(player, league.id);
            case 7:
              _context28.n = 5;
              break;
            case 8:
              _context28.n = 10;
              break;
            case 9:
              _context28.p = 9;
              _t0 = _context28.v;
              _iterator10.e(_t0);
            case 10:
              _context28.p = 10;
              _iterator10.f();
              return _context28.f(10);
            case 11:
              return _context28.a(2);
          }
        }, _callee26, this, [[4, 9, 10, 11]]);
      }));
      function updateHighScore(_x52, _x53, _x54) {
        return _updateHighScore.apply(this, arguments);
      }
      return updateHighScore;
    }()
  }, {
    key: "incrementPlayer",
    value: function () {
      var _incrementPlayer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(publicKey, league_id, field) {
        var amount,
          success,
          league,
          i,
          sql,
          params,
          _args29 = arguments;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.n) {
            case 0:
              amount = _args29.length > 3 && _args29[3] !== undefined ? _args29[3] : 1;
              if (!this.app.BROWSER) {
                _context29.n = 1;
                break;
              }
              return _context29.a(2, 1);
            case 1:
              if (field === 'score' || field === 'games_finished' || field === 'games_won' || field === 'games_tied' || field === 'games_started') {
                _context29.n = 2;
                break;
              }
              console.warn('League: Invalid field: ' + field);
              return _context29.a(2, 0);
            case 2:
              success = false; //This is more for live data
              league = this.returnLeague(league_id);
              if (league !== null && league !== void 0 && league.players) {
                for (i = 0; i < league.players.length; i++) {
                  if (league.players[i].publicKey === publicKey) {
                    league.players[i][field]++;
                    if (this.debug) {
                      console.debug("League [incrementPlayer] updated ".concat(field, ": in ").concat(league.id), JSON.parse(JSON.stringify(league.players[i])));
                    }
                    success = true;
                  }
                }
              }

              //if (!success) {
              //  return 0;
              //}
              sql = "UPDATE OR IGNORE players\n               SET ".concat(field, " = (").concat(field, " + ").concat(amount, "), ts = $ts\n               WHERE publickey = $publickey\n                 AND league_id = $league_id");
              params = {
                $ts: new Date().getTime(),
                $publickey: publicKey,
                $league_id: league_id
              };
              _context29.n = 3;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 3:
              this.entropy();
              return _context29.a(2, 1);
          }
        }, _callee27, this);
      }));
      function incrementPlayer(_x55, _x56, _x57) {
        return _incrementPlayer.apply(this, arguments);
      }
      return incrementPlayer;
    }()
  }, {
    key: "updatePlayerScore",
    value: function () {
      var _updatePlayerScore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(playerObj, league_id) {
        var league, i, sql, params;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              if (!this.app.BROWSER) {
                _context30.n = 1;
                break;
              }
              return _context30.a(2, 1);
            case 1:
              league = this.returnLeague(playerObj.league_id);
              if (league !== null && league !== void 0 && league.players) {
                for (i = 0; i < league.players.length; i++) {
                  if (league.players[i].publicKey === playerObj.publicKey) {
                    league.players[i]['score'] = playerObj.score;
                    if (this.debug) {
                      console.debug('League [updatePlayerScore] -- New Score: ' + playerObj.score, JSON.parse(JSON.stringify(league.players[i])));
                    }
                  }
                }
              }
              sql = "UPDATE players\n               SET score = $score,\n                   ts    = $ts\n               WHERE publickey = $publickey\n                 AND league_id = $league_id";
              params = {
                $score: playerObj.score,
                $ts: new Date().getTime(),
                $publickey: playerObj.publicKey,
                $league_id: league_id
              };
              _context30.n = 2;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 2:
              this.entropy();
              return _context30.a(2, 1);
          }
        }, _callee28, this);
      }));
      function updatePlayerScore(_x58, _x59) {
        return _updatePlayerScore.apply(this, arguments);
      }
      return updatePlayerScore;
    }() ////////////////////////////////////////////////
    // convenience functions for local data inserts //
    ////////////////////////////////////////////////
    /////////////////////////////
    // League Array Management //
    /////////////////////////////
  }, {
    key: "returnLeague",
    value: function returnLeague(league_id) {
      for (var i = 0; i < this.leagues.length; i++) {
        if (this.leagues[i].id === league_id) {
          return this.leagues[i];
        }
      }
      return null;
    }
  }, {
    key: "returnLeaguesByGame",
    value: function returnLeaguesByGame(gameName) {
      var ls = [];
      for (var i = 0; i < this.leagues.length; i++) {
        console.log(gameName, this.leagues[i].game);
        if (this.leagues[i].game === gameName) {
          ls.push(this.leagues[i]);
        }
      }
      return ls;
    }
  }, {
    key: "removeLeague",
    value: function () {
      var _removeLeague = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(league_id) {
        var i;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.n) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.leagues.length)) {
                _context31.n = 4;
                break;
              }
              if (!(this.leagues[i].id === league_id)) {
                _context31.n = 3;
                break;
              }
              this.leagues.splice(i, 1);
              if (!this.app.BROWSER) {
                _context31.n = 2;
                break;
              }
              _context31.n = 2;
              return this.app.storage.removeLocalForageItem("league_".concat(league_id));
            case 2:
              this.saveLeagues();
              return _context31.a(2);
            case 3:
              i++;
              _context31.n = 1;
              break;
            case 4:
              return _context31.a(2);
          }
        }, _callee29, this);
      }));
      function removeLeague(_x60) {
        return _removeLeague.apply(this, arguments);
      }
      return removeLeague;
    }()
  }, {
    key: "validateLeague",
    value: function validateLeague(obj) {
      var newObj = {};
      //
      // default values
      //
      newObj.id = (obj === null || obj === void 0 ? void 0 : obj.id) || '';
      newObj.game = (obj === null || obj === void 0 ? void 0 : obj.game) || 'Unknown';
      newObj.name = (obj === null || obj === void 0 ? void 0 : obj.name) || 'Unknown';
      newObj.admin = (obj === null || obj === void 0 ? void 0 : obj.admin) || '';
      newObj.contact = (obj === null || obj === void 0 ? void 0 : obj.contact) || '';
      newObj.status = (obj === null || obj === void 0 ? void 0 : obj.status) || 'public';
      newObj.description = (obj === null || obj === void 0 ? void 0 : obj.description) || '';
      newObj.ranking_algorithm = (obj === null || obj === void 0 ? void 0 : obj.ranking_algorithm) || 'EXP';
      newObj.default_score = (obj === null || obj === void 0 ? void 0 : obj.default_score) || 0;
      newObj.welcome = newObj.admin ? "Welcome to ".concat(newObj.name, "! Please make sure the admin has your email address or social media handle as well as your Saito address so they can contact you with arranged matches. \n            If you do not provide this information, you will be removed from the league. You should also make sure your Saito wallet is backed up so you can login to play games from any device.") : '';
      return newObj;
    }
  }, {
    key: "addLeague",
    value: function () {
      var _addLeague = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(obj) {
        var newLeague;
        return _regenerator().w(function (_context32) {
          while (1) switch (_context32.n) {
            case 0:
              if (obj) {
                _context32.n = 1;
                break;
              }
              return _context32.a(2);
            case 1:
              if (obj.id) {
                _context32.n = 2;
                break;
              }
              return _context32.a(2);
            case 2:
              if (this.returnLeague(obj.id)) {
                _context32.n = 3;
                break;
              }
              newLeague = this.validateLeague(obj); //
              // dynamic data-storage
              //
              newLeague.players = (obj === null || obj === void 0 ? void 0 : obj.players) || [];
              newLeague.rank = -1; //My rank in the league
              newLeague.numPlayers = (obj === null || obj === void 0 ? void 0 : obj.numPlayers) || 0;
              if ((obj === null || obj === void 0 ? void 0 : obj.rank) >= 0) {
                newLeague.rank = obj.rank;
              }
              this.leagues.push(newLeague);
              _context32.n = 3;
              return this.leagueInsert(newLeague);
            case 3:
              return _context32.a(2);
          }
        }, _callee30, this);
      }));
      function addLeague(_x61) {
        return _addLeague.apply(this, arguments);
      }
      return addLeague;
    }()
  }, {
    key: "updateLeague",
    value: function () {
      var _updateLeague = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(obj) {
        var oldLeague;
        return _regenerator().w(function (_context33) {
          while (1) switch (_context33.n) {
            case 0:
              if (obj) {
                _context33.n = 1;
                break;
              }
              return _context33.a(2);
            case 1:
              if (obj.id) {
                _context33.n = 2;
                break;
              }
              return _context33.a(2);
            case 2:
              oldLeague = this.returnLeague(obj.id);
              if (oldLeague) {
                _context33.n = 4;
                break;
              }
              _context33.n = 3;
              return this.addLeague(obj);
            case 3:
              return _context33.a(2);
            case 4:
              Object.assign(oldLeague, obj);
            case 5:
              return _context33.a(2);
          }
        }, _callee31, this);
      }));
      function updateLeague(_x62) {
        return _updateLeague.apply(this, arguments);
      }
      return updateLeague;
    }()
  }, {
    key: "validatePlayer",
    value: function validatePlayer(obj) {
      var newObj = {};
      newObj.publicKey = obj.publicKey || obj.publickey || '';
      newObj.score = obj.score || 0;
      newObj.games_started = obj.games_started || 0;
      newObj.games_finished = obj.games_finished || 0;
      newObj.games_won = obj.games_won || 0;
      newObj.games_tied = obj.games_tied || 0;
      newObj.email = obj.email || '';
      newObj.timestamp = obj.timestamp || 0;
      return newObj;
    }
  }, {
    key: "addLeaguePlayer",
    value: function () {
      var _addLeaguePlayer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(league_id, obj) {
        var league, newPlayer, z;
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.n) {
            case 0:
              league = this.returnLeague(league_id);
              if (league !== null && league !== void 0 && league.players) {
                _context34.n = 1;
                break;
              }
              console.error('League [validatePlayer] not found');
              return _context34.a(2);
            case 1:
              newPlayer = this.validatePlayer(obj);
              if (!newPlayer.score) {
                newPlayer.score = league.default_score;
              }
              //Make sure it is a number!
              newPlayer.score = parseInt(newPlayer.score);
              if (newPlayer.publicKey === this.publicKey) {
                league.score = newPlayer.score;
                if (!(league !== null && league !== void 0 && league.rank) || league.rank <= 0) {
                  league.rank = 0;
                  league.numPlayers = league.players.length;
                }
                if (league.admin && league.admin !== this.publicKey) {
                  league.unverified = newPlayer.email == '';
                }
              }

              //If we have the player already, just update the stats
              z = 0;
            case 2:
              if (!(z < league.players.length)) {
                _context34.n = 4;
                break;
              }
              if (!(league.players[z].publicKey === newPlayer.publicKey)) {
                _context34.n = 3;
                break;
              }
              league.players[z].score = newPlayer.score || league.players[z].score;
              league.players[z].games_started = newPlayer.games_started || league.players[z].games_started;
              league.players[z].games_won = newPlayer.games_won || league.players[z].games_won;
              league.players[z].games_tied = newPlayer.games_tied || league.players[z].games_tied;
              league.players[z].games_finished = newPlayer.games_finished || league.players[z].games_finished;
              return _context34.a(2);
            case 3:
              z++;
              _context34.n = 2;
              break;
            case 4:
              league.players.push(newPlayer);

              //
              if (!(this.app.BROWSER == 0)) {
                _context34.n = 5;
                break;
              }
              _context34.n = 5;
              return this.playerInsert(league_id, newPlayer);
            case 5:
              return _context34.a(2);
          }
        }, _callee32, this);
      }));
      function addLeaguePlayer(_x63, _x64) {
        return _addLeaguePlayer.apply(this, arguments);
      }
      return addLeaguePlayer;
    }()
  }, {
    key: "removeLeaguePlayer",
    value: function () {
      var _removeLeaguePlayer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(league_id, publicKey) {
        var league, i;
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.n) {
            case 0:
              if (!(publicKey == this.publicKey)) {
                _context35.n = 2;
                break;
              }
              _context35.n = 1;
              return this.removeLeague(league_id);
            case 1:
              return _context35.a(2);
            case 2:
              league = this.returnLeague(league_id);
              i = 0;
            case 3:
              if (!(i < league.players.length)) {
                _context35.n = 5;
                break;
              }
              if (!(league.players[i].publicKey === publicKey)) {
                _context35.n = 4;
                break;
              }
              league.players.splice(i, 1);

              //Force a new ranking calculation on next leaderboard load
              league.timestamp = 0;
              return _context35.a(3, 5);
            case 4:
              i++;
              _context35.n = 3;
              break;
            case 5:
              this.saveLeagues();
            case 6:
              return _context35.a(2);
          }
        }, _callee33, this);
      }));
      function removeLeaguePlayer(_x65, _x66) {
        return _removeLeaguePlayer.apply(this, arguments);
      }
      return removeLeaguePlayer;
    }()
  }, {
    key: "fetchLeagueLeaderboard",
    value: function fetchLeagueLeaderboard(league_id) {
      var _this9 = this;
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var league = this.returnLeague(league_id);
      var rank = 0;
      var myPlayerStats = null;
      if (!league) {
        console.error('League [fetchLeaderboard] not found');
        return;
      }

      //We need to reset this because this should be an ordered array
      //and if the scores have changed, we need to resort the players
      league.players = [];
      league.rank = -1;
      var cutoff = new Date().getTime() - 3 * 24 * 60 * 60 * 1000;
      this.sendPeerDatabaseRequestWithFilter('League', "SELECT *\n       FROM players\n       WHERE league_id = '".concat(league_id, "'\n         AND deleted = 0\n       ORDER BY score DESC, games_won DESC, games_tied DESC, games_finished DESC"), /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(res) {
          var _iterator11, _step11, p, _t1;
          return _regenerator().w(function (_context36) {
            while (1) switch (_context36.p = _context36.n) {
              case 0:
                if (!(res !== null && res !== void 0 && res.rows)) {
                  _context36.n = 11;
                  break;
                }
                _iterator11 = _createForOfIteratorHelper(res.rows);
                _context36.p = 1;
                _iterator11.s();
              case 2:
                if ((_step11 = _iterator11.n()).done) {
                  _context36.n = 7;
                  break;
                }
                p = _step11.value;
                if (!((p.games_finished == 0 && p.score !== league.default_score || p.timestamp < cutoff) && p.publickey !== _this9.publicKey && !league.admin)) {
                  _context36.n = 3;
                  break;
                }
                return _context36.a(3, 6);
              case 3:
                //
                // Count how many people are ranked above me in the leaderboard
                //
                rank++;
                if (!(p.publickey == _this9.publicKey)) {
                  _context36.n = 5;
                  break;
                }
                if (!(p.games_finished > 0)) {
                  _context36.n = 4;
                  break;
                }
                league.rank = rank;
                _context36.n = 5;
                break;
              case 4:
                league.rank = 0;
                myPlayerStats = p;
                return _context36.a(3, 6);
              case 5:
                _context36.n = 6;
                return _this9.addLeaguePlayer(league_id, p);
              case 6:
                _context36.n = 2;
                break;
              case 7:
                _context36.n = 9;
                break;
              case 8:
                _context36.p = 8;
                _t1 = _context36.v;
                _iterator11.e(_t1);
              case 9:
                _context36.p = 9;
                _iterator11.f();
                return _context36.f(9);
              case 10:
                league.numPlayers = rank;
                //Add me to bottom of list if I haven't played any games
                if (!myPlayerStats) {
                  _context36.n = 11;
                  break;
                }
                _context36.n = 11;
                return _this9.addLeaguePlayer(league_id, myPlayerStats);
              case 11:
                league.timestamp = new Date().getTime();
                if (!(mycallback != null)) {
                  _context36.n = 12;
                  break;
                }
                _context36.n = 12;
                return mycallback(res);
              case 12:
                if (_this9.app.BROWSER) {
                  _this9.saveLeagues();
                  _this9.app.connection.emit('leagues-render-request');
                  _this9.app.connection.emit('league-rankings-render-request');
                }
              case 13:
                return _context36.a(2);
            }
          }, _callee34, null, [[1, 8, 9, 10]]);
        }));
        return function (_x67) {
          return _ref4.apply(this, arguments);
        };
      }(), function (p) {
        if (p.hasService('league')) {
          return 1;
        }
        return 0;
      });
    }

    ////////////////////////////////////////////////
    // convenience functions for database inserts //
    ////////////////////////////////////////////////
  }, {
    key: "leagueInsert",
    value: function () {
      var _leagueInsert = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35(obj) {
        var sql, params;
        return _regenerator().w(function (_context37) {
          while (1) switch (_context37.n) {
            case 0:
              sql = "INSERT\n    OR IGNORE INTO leagues (id, game, name, admin, contact, status, description, ranking_algorithm, default_score) \n                    VALUES (\n    $id,\n    $game,\n    $name,\n    $admin,\n    $contact,\n    $status,\n    $description,\n    $ranking_algorithm,\n    $default_score\n    )";
              params = {
                $id: obj.id,
                $game: obj.game,
                $name: obj.name,
                $admin: obj.admin,
                $contact: obj.contact,
                $status: obj.status,
                $description: obj.description,
                $ranking_algorithm: obj.ranking_algorithm,
                $default_score: obj.default_score
              };
              _context37.n = 1;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 1:
              return _context37.a(2);
          }
        }, _callee35, this);
      }));
      function leagueInsert(_x68) {
        return _leagueInsert.apply(this, arguments);
      }
      return leagueInsert;
    }()
  }, {
    key: "playerInsert",
    value: function () {
      var _playerInsert = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36(league_id, obj) {
        var sql, params;
        return _regenerator().w(function (_context38) {
          while (1) switch (_context38.n) {
            case 0:
              sql = "INSERT\n    OR IGNORE INTO players (league_id, publickey, score, ts) \n                                VALUES (\n    $league_id,\n    $publickey,\n    $score,\n    $ts\n    )";
              params = {
                $league_id: league_id,
                $publickey: obj.publicKey,
                $score: obj.score,
                $ts: new Date().getTime()
              };
              _context38.n = 1;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 1:
              return _context38.a(2);
          }
        }, _callee36, this);
      }));
      function playerInsert(_x69, _x70) {
        return _playerInsert.apply(this, arguments);
      }
      return playerInsert;
    }()
  }, {
    key: "pruneOldPlayers",
    value: function () {
      var _pruneOldPlayers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee37() {
        var sql, cutoff;
        return _regenerator().w(function (_context39) {
          while (1) switch (_context39.n) {
            case 0:
              /*
              Need to do an inner join to select for default leaderboards only
              */
              sql = "UPDATE players\n               SET deleted = 1\n               WHERE players.timestamp < ?";
              cutoff = new Date().getTime() - this.inactive_player_cutoff;
              _context39.n = 1;
              return this.app.storage.runDatabase(sql, [cutoff], 'league');
            case 1:
              return _context39.a(2);
          }
        }, _callee37, this);
      }));
      function pruneOldPlayers() {
        return _pruneOldPlayers.apply(this, arguments);
      }
      return pruneOldPlayers;
    }()
  }, {
    key: "entropy",
    value: function () {
      var _entropy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee38() {
        var now, check_threshold, decay_threshold, _iterator12, _step12, league, _results, _results2, sql, params, results, _t10;
        return _regenerator().w(function (_context40) {
          while (1) switch (_context40.p = _context40.n) {
            case 0:
              now = new Date().getTime();
              check_threshold = 1000 * 60 * 60 * 24; //Check several times a day to catch up...
              decay_threshold = 1000 * 60 * 60 * 48; //Decay 1 point per day...
              //Check if we have deployed the decay function in the last day...
              if (!(now - this.last_prune > check_threshold)) {
                _context40.n = 9;
                break;
              }
              this.last_prune = now;
              _iterator12 = _createForOfIteratorHelper(this.leagues);
              _context40.p = 1;
              _iterator12.s();
            case 2:
              if ((_step12 = _iterator12.n()).done) {
                _context40.n = 6;
                break;
              }
              league = _step12.value;
              if (!(league.admin === '')) {
                _context40.n = 5;
                break;
              }
              // Tier One: "new" players
              sql = "UPDATE OR IGNORE players\n\t\t\t               SET score = (score - 1), ts = (ts + ".concat(decay_threshold, ")\n\t\t\t               WHERE ts < ").concat(now - decay_threshold, "\n\t\t\t                 AND league_id = $league_id AND score > 0 AND games_finished < 10");
              params = {
                $league_id: league.id
              };
              _context40.n = 3;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 3:
              results = _context40.v;
              if ((_results = results) !== null && _results !== void 0 && _results.changes) {
                console.info("Apply Entropy to ".concat(league.name, " League: ").concat(results.changes));
              }

              // Tier Two: established players
              sql = "UPDATE OR IGNORE players\n\t\t\t               SET score = (score - 1), ts = (ts + ".concat(5 * decay_threshold, ")\n\t\t\t               WHERE ts < ").concat(now - 5 * decay_threshold, "\n\t\t\t                 AND league_id = $league_id AND score > 0 AND games_finished < 100");
              _context40.n = 4;
              return this.app.storage.runDatabase(sql, params, 'league');
            case 4:
              results = _context40.v;
              if ((_results2 = results) !== null && _results2 !== void 0 && _results2.changes) {
                console.info("Apply Entropy to ".concat(league.name, " League: ").concat(results.changes));
              }
            case 5:
              _context40.n = 2;
              break;
            case 6:
              _context40.n = 8;
              break;
            case 7:
              _context40.p = 7;
              _t10 = _context40.v;
              _iterator12.e(_t10);
            case 8:
              _context40.p = 8;
              _iterator12.f();
              return _context40.f(8);
            case 9:
              return _context40.a(2);
          }
        }, _callee38, this, [[1, 7, 8, 9]]);
      }));
      function entropy() {
        return _entropy.apply(this, arguments);
      }
      return entropy;
    }()
  }]);
}(ModTemplate);
module.exports = League;